"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var context_1 = require("../../context");
var router_1 = require("./router");
/**
 * ClientRouter component
 *
 * @remarks
 * React component which keeps the Shopify admin url in sync with the app url
 *
 * @public
 */
var ClientRouter = /** @class */ (function (_super) {
    __extends(ClientRouter, _super);
    function ClientRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClientRouter.prototype.componentDidMount = function () {
        var history = this.props.history;
        this.unsubscribe = router_1.handleRouteChange(this.context, history);
    };
    ClientRouter.prototype.componentWillUnmount = function () {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    };
    ClientRouter.prototype.render = function () {
        return null;
    };
    ClientRouter.contextType = context_1.AppBridgeContext;
    return ClientRouter;
}(react_1.default.Component));
exports.default = ClientRouter;
